import { PartnerTabsNav, type PartnerTabItem } from './PartnerTabsNav';

const tabs: PartnerTabItem[] = [
  {
    value: 'profile',
    labelKey: 'common.Sidebar.Settings',
    to: '/partner/organization'
  },
  {
    value: 'users',
    labelKey: 'partner.settings.tabs.users',
    to: '/partner/organization/users'
  }
];

export function PartnerSettingsTabsNav() {
  return <PartnerTabsNav tabs={tabs} />;
}
